import React, { useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import Pagination from "../../../../components/Pagination";
import convertToExcel from "../../../../components/ExportToExcel";

const UserWiseStock = () => {
  const [stockData, setStockData] = useState();
  const [allData, setAllData] = useState([]);

  const { sendRequest: getWarehouseStock } = useHttp();

  useEffect(() => {
    const data = {
      orgId: localStorage.getItem("orgId"),
    };

    getWarehouseStock(
      {
        url: `/api/userCurrentStock/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        console.log("userCurrentStock",res);
        setStockData(res);
        setAllData(res);
      }
    );
  }, [getWarehouseStock]);

  const handleSearch = (e) => {
    const filtertext = e.target.value.trim().toLowerCase();
  
    const filterdata = allData.filter((item) => {
      return (
        // Ensure that the item fields are not null/undefined and compare case-insensitively
        (item?.executiveName?.toString().toLowerCase().includes(filtertext)) ||
        (item?.itemId?.toString().toLowerCase().includes(filtertext)) ||
        (item?.productName?.toString().toLowerCase().includes(filtertext)) ||
        (item?.productSubTypeName?.toString().toLowerCase().includes(filtertext)) ||
        (item?.productTypeName?.toString().toLowerCase().includes(filtertext)) // add more fields if necessary
      );
    });
  
    setStockData(filterdata); // Update stock data with filtered results
  };
  
  

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems =
    stockData && stockData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const fieldsToExport = [
    "executiveName",
    "productName",
    "itemId",
    "productSubTypeName",
    "productTypeName",
    "quantity",
    "unitAbbreviation",
    "totalAmount",
    "salesRate",
  ];

  const customHeaders = [
    "Field Officer Name",
    "Product Name",
    "Item id",
    "Product Item Sub Type",
    "Product Item Type",
    "Item Quantity",
    "Unit",
    "Amount",
    "Sales Rate",
  ];

  const handleExportExcel = () => {
    const filename = "UserwiseStock.xlsx";
    //console.log(fieldsToExport, customHeaders);

    convertToExcel(stockData, fieldsToExport, filename, customHeaders);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-3 d-flex align-items-center">
            <label className="card-title mx-3 my-3">
              User wise Stock
            </label>
          </div>
          {/* Search Box aligned to the right */}
          <div className="col-3 mt-3">
            <input
              type="text"
              name="q"
              className="form-control"
              placeholder="Search..."
              onKeyUp={(e) => handleSearch(e)}
            />
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="text-right my-2">
                      <button
                        type="button"
                        className="btn btn-sm btn-warning"
                        onClick={handleExportExcel}
                      >
                        <i className="fas fa-file-excel"></i>
                      </button>
                    </div>
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Employee Name</th>
                          <th>Product Name</th>
                          <th>Item id</th>
                          <th>Product Item Sub Type</th>
                          <th>Product Item Type</th>
                          <th>Item Quantity</th>
                          <th>Unit</th>
                          <th>Amount</th>
                          <th>Sales Rate</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.executiveName}</td>
                                <td>{itm.productName}</td>
                                <td>{itm.itemId}</td>

                                <td>{itm.productSubTypeName}</td>
                                <td>{itm.productTypeName}</td>

                                <td>{itm.quantity}</td>

                                <td>{itm.unitAbbreviation}</td>
                                <td>{itm.totalAmount}</td>
                                <td>{itm.salesRate}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={(stockData && stockData.length) || 0}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default UserWiseStock;
